import z from 'zod';

export const PromotionCtaTypeSchema = z.enum([
  'LaunchDeposit',
  'LaunchGame',
  'NavigationRegister',
  'NavigationReferral',
  'NavigationLobby',
  'NavigationPromotions',
  'NavigationRewards',
]);

export const BannerSchema = z.object({
  title: z.string().optional(),
  imageUrl: z.string(),
  miniImageUrl: z.string().optional(),
  cta: z
    .object({
      type: PromotionCtaTypeSchema,
      id: z.number().optional(),
      gameId: z.number().optional(),
    })
    .optional(),
  promotionId: z.number().optional(),
  promotionTitle: z.string().optional(),
  promoType: z.string().optional(),
});

export const BannersResponseSchema = z.object({
  banners: z.array(BannerSchema),
});
